export default {
	USER_SEARCH: 'companies/:company_id/users/search/',
	USERS: 'companies/:company_id/users/'

}
